import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { ArrowLeftCircleIcon } from "@heroicons/react/24/outline";
import { logo } from "@/constants";
import Footer from "@/components/Footer";
import { CartProvider } from "@/hooks/useCart";

const MainLayout = () => {
    const { businessName } = useParams();
    const navigate = useNavigate();

    return (
        <>
            <CartProvider businessName={businessName}>
                <header className="bg-primary flex gap-4 items-center justify-between p-4">
                    <div
                        onClick={() => navigate(-1)}
                        className="rounded-2xl hover:rounded-lg cursor-pointer hover:scale-110 transition-all bg-white text-primary-dark p-1"
                    >
                        <ArrowLeftCircleIcon className="w-7 h-7" />
                    </div>
                    <Link
                        to={"/"}
                        className="bg-white hover:scale-105 transition-all shadow-lg rounded-lg h-12 flex items-center overflow-hidden w-fit p-2"
                    >
                        <img className="w-16" src={`../../${logo}`} alt="foodb" />
                    </Link>
                </header>
                <main className="bg-shade-light text-center">
                    <Outlet />
                </main>
                <Footer />
            </CartProvider>
        </>
    );
};
export default MainLayout;
